import { render, staticRenderFns } from "./SiteNotAvailableTid3.vue?vue&type=template&id=225ebff4&scoped=true"
import script from "./SiteNotAvailableTid3.vue?vue&type=script&lang=js"
export * from "./SiteNotAvailableTid3.vue?vue&type=script&lang=js"
import style0 from "./SiteNotAvailableTid3.vue?vue&type=style&index=0&id=225ebff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ebff4",
  null
  
)

export default component.exports